module.exports = __webpack_public_path__ + "images/product-navigation/portable-charging-case-12414693.svg";